// components
import message from 'antd-v3/es/message'

import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import {
  caregiverAssignedFacilities$,
  caregiverAssignedPatients$,
  caregiverUuid$,
  fetchCaregiverProfile,
  setCaregiverAssignedPatients,
  setCaregiverSearchedPatients
} from 'src/store/modules/caregiver'

// constants
import {
  CAREGIVER_MANAGEMENT_FACILITIES_ADD_MESSAGE,
  CAREGIVER_MANAGEMENT_FACILITIES_DELETE_MESSAGE,
  CAREGIVER_MANAGEMENT_PATIENTS_ADD_MESSAGE,
  CAREGIVER_MANAGEMENT_PATIENTS_DELETE_MESSAGE,
  CAREGIVER_POST_ADD_ASSIGNED_FACILITY,
  CAREGIVER_POST_DELETE_ASSIGNED_FACILITY,
  DELETE_ASSIGNED_CAREGIVER,
  DELETE_CAREGIVER_PATIENT_LIST,
  GET_CAREGIVER_PATIENT_LIST,
  PATIENTS,
  POST_CAREGIVER_PATIENT_LIST
} from 'src/constants'

export const fetchCaregiverAssignedPatients =
  (config = {}) =>
  async (dispatch) => {
    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_CAREGIVER_PATIENT_LIST,
          ...config
        }
      })

      dispatch(setCaregiverAssignedPatients(items))

      return meta
    } catch (err) {
      catchError(err)
    }
  }

export const fetchCaregiverSearchedPatients =
  (config = {}) =>
  async (dispatch) => {
    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: PATIENTS,
          ...config
        }
      })

      dispatch(setCaregiverSearchedPatients(items))

      return meta
    } catch (err) {
      catchError(err)
    }
  }

export const deleteCaregiverPatient =
  (config = {}) =>
  async () => {
    try {
      await httpClient.request({
        method: 'delete',
        url: {
          pathname: DELETE_ASSIGNED_CAREGIVER,
          ...config
        }
      })

      message.success(CAREGIVER_MANAGEMENT_PATIENTS_DELETE_MESSAGE)

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const saveCaregiverPatientList =
  (config = {}) =>
  async (dispatch, getState) => {
    const { payload = {}, params = {} } = config
    const state = getState()
    const caregiverAssignedFacilities = caregiverAssignedFacilities$(state)
    const caregiverUuid = caregiverUuid$(state)

    try {
      await httpClient.request({
        method: 'post',
        url: {
          pathname: POST_CAREGIVER_PATIENT_LIST,
          params
        },
        payload
      })

      message.success(CAREGIVER_MANAGEMENT_PATIENTS_ADD_MESSAGE)

      if (caregiverAssignedFacilities.length) {
        const config = {
          params: {
            uuid: caregiverUuid
          }
        }

        await dispatch(fetchCaregiverProfile(config))
      }

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const deleteCaregiverPatientList =
  (config = {}) =>
  async () => {
    const { payload = {}, params = {} } = config

    try {
      await httpClient.request({
        method: 'post',
        url: {
          pathname: DELETE_CAREGIVER_PATIENT_LIST,
          params
        },
        payload
      })

      message.success(CAREGIVER_MANAGEMENT_PATIENTS_DELETE_MESSAGE)

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const saveCaregiverFacility =
  (config = {}) =>
  async (dispatch, getState) => {
    const { payload = {}, params = {} } = config
    const caregiverAssignedPatients = caregiverAssignedPatients$(getState())

    try {
      await httpClient.request({
        method: 'post',
        url: {
          pathname: CAREGIVER_POST_ADD_ASSIGNED_FACILITY,
          params
        },
        payload
      })

      message.success(CAREGIVER_MANAGEMENT_FACILITIES_ADD_MESSAGE)

      if (caregiverAssignedPatients.length) {
        dispatch(setCaregiverAssignedPatients([]))
      }
      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const deleteCaregiverFacility =
  (config = {}) =>
  async () => {
    const { params = {}, payload = {} } = config

    try {
      await httpClient.request({
        method: 'post',
        url: {
          pathname: CAREGIVER_POST_DELETE_ASSIGNED_FACILITY,
          params
        },
        payload
      })

      message.success(CAREGIVER_MANAGEMENT_FACILITIES_DELETE_MESSAGE)

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }
